// extracted by mini-css-extract-plugin
export default {"overlay":"gz-z","bodyOpen":"hz-z","content":"iz-z","header":"jz-z","close":"kz-z","closeNoHeading":"lz-z"};